import React from 'react'
import {
    FormGroup,
    Input,
    Label,
    Col
  } from 'reactstrap';
import Subtitle from '../../subtitle/Subtitle'
export default props => {
    return (
        <div>
            <Subtitle text="Astrea"/>
            <FormGroup row className="my-0">
                <Col xs="12" lg="6">
                    <FormGroup>
                        <Label htmlFor="namespace">Namespace</Label>
                        <Input type="text" id="namespace" autoFocus placeholder="astrea.namespace" defaultValue={props.entity.namespace} onChange={event => props.handleChange('namespace', event.target.value)}/>
                    </FormGroup>
                </Col>
                <Col xs="12" lg="6">
                    <FormGroup>
                        <Label htmlFor="environment">Ambiente</Label>
                        <Input type="select" id="environment" defaultValue={props.entity.environment} onChange={event => props.handleChange('environment', event.target.value)}>
                            <option value="">-- Selecionar</option>
                            <option value="LOCAL">Local</option>
                            <option value="HOMOLOG">Homologação</option>
                            <option value="PRODUCTION">Produção</option>
                        </Input>
                    </FormGroup>
                </Col>
            </FormGroup>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/components/migration-form/astrea/MigrationAstreaForm.js